package util

import kotlinx.browser.document
import kotlinx.html.*
import kotlinx.html.js.div
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLElement


object InstructionsUI {
    fun addInstructionsHtmlTo(parent: TagConsumer<HTMLElement>, content: DIV.() -> Unit) {
        parent.div {
            id = "instructions"
            classes = setOf("hidden")
            content()
            img(classes = "close", src = "/editor/icons/close.svg", alt = "X") {
                onClickFunction = {
                    document.getElementById("instructions")?.classList?.toggle("hidden")
                }
            }
        }
        parent.div("fab hoverable") {
            img(classes = "icon", src = "/editor/icons/help.svg", alt = "?")
            onClickFunction = {
                document.getElementById("instructions")?.classList?.toggle("hidden")
            }
        }
    }
}